import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import * as Sentry from '@sentry/angular-ivy';
import {confirm} from 'devextreme/ui/dialog';
import {forkJoin} from 'rxjs';
import {take} from 'rxjs/operators';
import {RequisitionLabelViewModel} from '../../../../shared/models/ocl';
import {UrlProviderService} from '../../../../shared/services/general';
import {RequisitionService} from '../../services/requisition.service';
import {OrderService} from "../../../features/result-entry/services/order.service";
import {OrdersService} from "../../services/orders.service";

@Component({
  selector: 'app-printer-dialog-multiple',
  templateUrl: './printer-dialog-multiple.component.html',
  styleUrls: ['./printer-dialog-multiple.component.scss'],
})
export class PrinterDialogMultipleComponent implements OnInit, OnChanges {
  @Input() public isOrder: boolean = false;
  @Input() public popupVisible = false;
  @Input() public requisitionIds?: number[];
  @Output() public closeEvent = new EventEmitter();

  public isLoading = false;
  private clientAppUpAndRunning = false;
  private clientAppBlocked = false;
  private showingConfirm = false;
  public loading = false;
  public printers: [] = [];
  public selectedPrinter: any = undefined;

  constructor(private requisitionService: RequisitionService, private orderService: OrdersService, private urlProvider: UrlProviderService) {
  }

  // tslint:disable-next-line:use-lifecycle-interface
  public ngOnChanges(changes: import('@angular/core').SimpleChanges): void {
    if (changes.popupVisible && changes.popupVisible.currentValue) {
      JSPM.JSPrintManager.license_url = `${this.urlProvider.ServerUrl}jspm`;
      JSPM.JSPrintManager.auto_reconnect = true;
      JSPM.JSPrintManager.start()
        .then(() => console.log('Printer tool connected'))
        .catch(e => {
          Sentry.captureException(e);
        });
      this.checkPrinterClientApp();
    }
  }

  public ngOnInit() {
    JSPM.JSPrintManager.auto_reconnect = false;
  }

  public closing() {
    this.closeEvent.emit();
  }

  public get LoadingPrinters() {
    return this.loading && this.printers.length === 0;
  }

  private checkPrinterClientApp() {
    this.loading = true;
    JSPM.JSPrintManager.WS.onStatusChanged = (() => {
      const instance = this;
      return function WSStatusChanged() {
        if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Open) {
          JSPM.JSPrintManager.getPrintersInfo().then(printersList => {
            // @ts-ignore
            instance.printers = printersList;
            instance.loading = false;
          }).catch(e => {
            Sentry.captureException(e);
          });
        } else if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Closed) {
          if (!instance.showingConfirm && instance.popupVisible) {
            const response = confirm(
              // tslint:disable-next-line:max-line-length
              `Printer Client App is not running. Restart app to use feature or download it. \n Would you like to be redirected to download site?`,
              'Download Confirmation',
            );
            instance.showingConfirm = true;
            instance.loading = false;

            const closeEvent = instance.closeEvent;
            response.then(result => {
              instance.clientAppUpAndRunning = false;
              instance.showingConfirm = false;
              if (result) {
                window.open('https://www.dropbox.com/t/b04SMciBx6QJefst', '_blank');
              }
              closeEvent.emit();
            });
          }
        } else if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Blocked) {
          console.log('JSPM has blacklisted this website!');
          instance.clientAppBlocked = true;
          instance.clientAppUpAndRunning = true;
        }
      };
    })();
  }

  public sendToPrinter() {
    JSPM.JSPrintManager.start()
      .then(() => console.log('Printer tool connected'))
      .catch(e => {
        Sentry.captureException(e);
      });
    JSPM.JSPrintManager.WS.onStatusChanged = () => {
      if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Open) {
        this.isLoading = true;
        const cpjg = new JSPM.ClientPrintJobGroup();

        const arrayRequest: any[] = [];
        this.requisitionIds?.forEach(x => {
          const labels = this.isOrder ? this.orderService.getLabels(x) : this.requisitionService.getLabels(x);
          arrayRequest.push(labels);
        });

        let requisitionLabels: RequisitionLabelViewModel[] = [];
        forkJoin(arrayRequest).pipe(take(1)).subscribe({
          next: value => {
            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < value.length; i++) {
              requisitionLabels = requisitionLabels.concat(value[i] as any);
            }
          },
          complete: () => {
            requisitionLabels.forEach((label) => {
              const cpj2 = new JSPM.ClientPrintJob();
              cpj2.clientPrinter = new JSPM.InstalledPrinter(this.selectedPrinter.name);
              if (this.selectedPrinter.name.toUpperCase().includes('ZPL') || this.selectedPrinter.name.toUpperCase().includes('ZEBRA')) {
                cpj2.printerCommands = label.zpl;
              }

              if (this.selectedPrinter.name.toUpperCase().includes('EPL')) {
                cpj2.printerCommands = label.epl;
              }

              cpjg.jobs.push(cpj2);
            });
            this.isLoading = false;
            cpjg.sendToClient()
              .then(() => console.log('Printer tool connected'))
              .catch(e => {
                Sentry.captureException(e);
              });
          }
        });
      }
    };
  }

  public printerChanged(printer: any) {
    if (printer.value) {
      const printerString = JSON.stringify(printer.value);
      localStorage.setItem('printer', printerString);
      this.selectedPrinter = printer.value;
    } else {
      // @ts-ignore
      localStorage.setItem('printer', null);
    }
  }
}
